import moment, { Moment } from 'moment';

export interface LedgerAdjustment {
  policyId: string;
  organizationId: string;
  environment: string;
  amount: number;
  description: string;
  currency: string;
  balance: number;
}

export class StartDateAdjustmentDetails {
  readonly deferUpdate: boolean;
  readonly deferUpdateUntil: Moment | undefined;
  readonly billingDay: number | undefined;
  readonly billingMonth: number | undefined;
  readonly startDate: Moment;
  readonly ledgerAdjustments: LedgerAdjustment[];
  readonly currentBalance: number | undefined;

  constructor(init: {
    deferUpdate: boolean;
    deferUpdateUntil: Moment | undefined;
    billingDay: number | undefined;
    billingMonth: number | undefined;
    startDate: Moment;
    ledgerAdjustments: LedgerAdjustment[];
    currentBalance: number | undefined;
  }) {
    this.deferUpdate = init.deferUpdate;
    this.deferUpdateUntil = init.deferUpdateUntil;
    this.billingDay = init.billingDay;
    this.billingMonth = init.billingMonth;
    this.startDate = init.startDate;
    this.ledgerAdjustments = init.ledgerAdjustments;
    this.currentBalance = init.currentBalance;
  }

  static fromJSON(data: Record<string, unknown>): StartDateAdjustmentDetails {
    const rawAdjustments = (data.ledger_adjustments as Record<string, unknown>[]) || [];
    const ledgerAdjustments: LedgerAdjustment[] = rawAdjustments.map((entry) => ({
      policyId: entry.policy_id as string,
      organizationId: entry.organization_id as string,
      environment: entry.environment as string,
      amount: entry.amount as number,
      description: entry.description as string,
      currency: entry.currency as string,
      balance: entry.balance as number,
    }));

    return new StartDateAdjustmentDetails({
      deferUpdate: data.defer_update as boolean,
      deferUpdateUntil: data.defer_update_until ? moment(data.defer_update_until as string) : undefined,
      billingDay: data.billing_day as number | undefined,
      billingMonth: data.billing_month as number | undefined,
      startDate: moment(data.start_date as string),
      ledgerAdjustments,
      currentBalance: data.current_balance as number | undefined,
    });
  }
}
